import React,{useEffect,useState} from 'react'
import {Button, Form, Input} from 'antd'
import { MailOutlined } from '@ant-design/icons'
import {apiSendSecondValidateCode, apiSSOLogin} from "../request/api";
import {messageTips} from "../utils";


export default function SecondValidate(props) {
    const { validateId,form,style,refreshData,loading,loadingText,imgCode,refreshImageCode,IDasImageShow,setIDasImageShow} = props;
    const [buttonText,setButtonText] = useState("获取二次验证码");
    const [disabled,setDisabled] = useState(false);
    const [useFids,setUseFids] = useState([])
    const [fid,setFid] = useState(validateId);
    const sendSecondValidateCode = () => {
        if(fid){
            let username = form.getFieldValue("Phone");
            let params = {
                username:username,fid:fid
            };
            apiSendSecondValidateCode(params).then(res=> {
                loading(false);loadingText("登录中...")
                if(res.data.IsSuccess) {
                    setDisabled(true);
                    setIDasImageShow(false);
                    setUseFids([...useFids,params.fid]);
                    setFid("");
                    let time = 60;
                    let interval= setInterval(()=>{
                        time--;
                        setButtonText(time+"秒后重新获取");
                        if(time === 0) {
                            setButtonText("重新获取二次验证码");
                            setDisabled(false);
                            clearInterval(interval)
                        }
                    },1000)
                    form.setFieldsValue({SecondaryVerifyFid:res.data.data.fid})
                    messageTips("验证码已成功发送至绑定的手机号，请注意查收！",'success')
                }else {
                    //清空fid 重新获取
                    setFid("");
                    messageTips(res.data.msg,'error')
                }
            })
        }else{
            if(!IDasImageShow) {
                setIDasImageShow(true);
                refreshImageCode();
            }else {
                let loginType = refreshData.LoginType;
                if(loginType === "password") {
                    form.validateFields(["ImgCode"]).then(res=> {
                        loading(true);loadingText("正在发送...")
                        let code = form.getFieldValue("ImgCode");
                        refreshData.ImgCodeId = imgCode;
                        refreshData.ImgCode = code;
                        apiSSOLogin(refreshData).then(res=> {
                            if(res.data.IsSuccess) {
                                if(res.data.data) {
                                    if( res.data.data.IsNeedSecondFactor) {
                                        setFid(res.data.data.Fid);
                                        let username = form.getFieldValue("Phone");
                                        let params = {
                                            username:username,fid:res.data.data.Fid
                                        };
                                        apiSendSecondValidateCode(params).then(res=> {
                                            loading(false);loadingText("登录中...")
                                            if(res.data.IsSuccess) {
                                                setDisabled(true);
                                                setIDasImageShow(false);
                                                setUseFids([...useFids,params.fid]);
                                                setFid("");
                                                let time = 60;
                                                let interval= setInterval(()=>{
                                                    time--;
                                                    setButtonText(time+"秒后重新获取");
                                                    if(time === 0) {
                                                        setButtonText("重新获取二次验证码");
                                                        setDisabled(false);
                                                        clearInterval(interval)
                                                    }
                                                },1000)
                                                form.setFieldsValue({SecondaryVerifyFid:res.data.data.fid})
                                                messageTips("验证码已成功发送至绑定的手机号，请注意查收！",'success')
                                            }else {
                                                messageTips(res.data.msg,'error')
                                            }
                                        })
                                    }
                                }
                            }else {
                                refreshImageCode();
                                messageTips(res.data.msg,'error');
                                setDisabled(false);
                                loading(false);loadingText("登录中...");
    
                            }
                        })
                    }).catch(err=> {
    
                    })
                }else {
                    if(IDasImageShow) {
                        form.validateFields(["ImgCode"]).then(res=> {
                            loading(true);loadingText("正在发送...")
                            let code = form.getFieldValue("ImgCode");
                            refreshData.ImgCodeId = imgCode;
                            refreshData.ImgCode = code;
                            apiSSOLogin(refreshData).then(res=> {
                                if(res.data.IsSuccess) {
                                    if(res.data.data) {
                                        if( res.data.data.IsNeedSecondFactor) {
                                            setFid(res.data.data.Fid);
                                            let username = form.getFieldValue("Phone");
                                            let params = {
                                                username:username,fid:res.data.data.Fid
                                            };
                                            apiSendSecondValidateCode(params).then(res=> {
                                                loading(false);loadingText("登录中...")
                                                if(res.data.IsSuccess) {
                                                    setDisabled(true);
                                                    setIDasImageShow(false);
                                                    setUseFids([...useFids,params.fid]);
                                                    setFid("");
                                                    let time = 60;
                                                    let interval= setInterval(()=>{
                                                        time--;
                                                        setButtonText(time+"秒后重新获取");
                                                        if(time === 0) {
                                                            setButtonText("重新获取二次验证码");
                                                            setDisabled(false);
                                                            clearInterval(interval)
                                                        }
                                                    },1000)
                                                    form.setFieldsValue({SecondaryVerifyFid:res.data.data.fid})
                                                    messageTips("验证码已成功发送至绑定的手机号，请注意查收！",'success')
                                                }else {
                                                    messageTips(res.data.msg,'error')
                                                }
                                            })
                                        }
                                    }
                                }else {
                                    refreshImageCode();
                                    messageTips(res.data.msg,'error');
                                   // setDisabled(false);
                                    loading(false);loadingText("登录中...");
    
                                }
                            })
                        }).catch(err=> {
    
                        })
                    }else {
                        loading(true);loadingText("正在发送...")
                        let code = form.getFieldValue("ImgCode");
                        refreshData.ImgCodeId = imgCode;
                        refreshData.ImgCode = code;
                        apiSSOLogin(refreshData).then(res=> {
                            if(res.data.IsSuccess) {
                                if(res.data.data) {
                                    if( res.data.data.IsNeedSecondFactor) {
                                        setFid(res.data.data.Fid);
                                        let username = form.getFieldValue("Phone");
                                        let params = {
                                            username:username,fid:res.data.data.Fid
                                        };
                                        apiSendSecondValidateCode(params).then(res=> {
                                            loading(false);loadingText("登录中...")
                                            if(res.data.IsSuccess) {
                                                setDisabled(true);
                                                setIDasImageShow(false)
                                                setUseFids([...useFids,params.fid]);
                                                setFid("");
                                                let time = 60;
                                                let interval= setInterval(()=>{
                                                    time--;
                                                    setButtonText(time+"秒后重新获取");
                                                    if(time === 0) {
                                                        setButtonText("重新获取二次验证码");
                                                        setDisabled(false);
                                                        clearInterval(interval)
                                                    }
                                                },1000)
                                                form.setFieldsValue({SecondaryVerifyFid:res.data.data.fid})
                                                messageTips("验证码已成功发送至绑定的手机号，请注意查收！",'success')
                                            }else {
                                                messageTips(res.data.msg,'error')
                                            }
                                        })
                                    }
                                }
                            }else {
                                refreshImageCode();
                                messageTips(res.data.msg,'error');
                                setDisabled(false);
                                loading(false);loadingText("登录中...");
    
                            }
                        })
                    }
    
                }
            }
    
        }

    }
    useEffect(()=>{

    },[]);
    useEffect(()=>{
        setFid(validateId);
        setUseFids([...useFids,validateId]);
    },[validateId]);

    return (
        <div className="mobile-message-code">
            <Form.Item name="SecondaryVerifyFid" hidden={true}>
                <Input/>
            </Form.Item>
            <Form.Item name="SecondaryVerifyCode" rules={[{required: true, message: '请输入二次校验码！',}]} style={{marginBottom:0}}>
                <Input maxLength={6}
                       rules={[{required: true, msg:"二次验证码不能为空"},]}
                       prefix={<MailOutlined  className="site-form-item-icon" />}
                       placeholder="二次验证码"
                />
            </Form.Item>
            <Button onClick={sendSecondValidateCode} disabled={disabled}>{buttonText}</Button>
        </div>
    )
}
